'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _lodash = require('lodash');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  lined: function lined(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'border-bottom: solid 1px ' + theme.colors.base.chrome200 + ';'
    };
  },
  selectableHover: function selectableHover(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      cursor: pointer;\n      &:hover {\n        background-color: ' + theme.colors.base.selectableHover + ';\n        box-shadow: 0 2px 1px 0 ' + theme.colors.base.shadowLight + ';\n      }\n    '
    };
  },
  selected: function selected(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.selectableActive + ';\n      box-shadow: 0 2px 1px 0 ' + theme.colors.base.shadow + ';\n    '
    };
  }
};

var Row = function Row(props) {
  var componentProps = (0, _lodash.omit)(props, ['modifiers']);
  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, componentProps);
};

// This acts as our <tr> element
var styles = function styles() {
  return '\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 1;\n  transition: all 200ms ease;\n  vertical-align: top;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      selectableActive: _propTypes2.default.string.isRequired,
      selectableHover: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Row', (0, _styledComponents2.default)(Row), styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ListTable/Row.js
// module id = 1599
// module chunks = 2